import { createAsyncThunk } from '@reduxjs/toolkit';
import { GETUSERDETAIL_API_URL } from '@custom/constant';

const userDetails = createAsyncThunk('userDetails', async (_, { rejectWithValue }) => {
    const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId')
    const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId')
    const token = sessionStorage.getItem('token') || localStorage.getItem('token')
    try {
        let url = `${GETUSERDETAIL_API_URL}?hospitalId=${hospitalId}&userId=${userId}`;
        let response = await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
            }
        })

        if (!response.ok) {
            return rejectWithValue(await response.json());
        }

        return await response.json()
    } catch (error) {
        return error;
    }
});

export default userDetails;
